<template>
  <div class="raised p-3 rounded">
    <div class="loan-title text-center bottom-border mb-2 pb-2">
      <span class="h4">{{ title }}</span>
      <div><slot name="subtitle"></slot></div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/utils/TitleCard.vue